import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { getTableLang } from "../../Utils/Inits/getTableLang";
import { chooseListWithButtons, displayQrCode, errorToast, showModal, successToast } from "../../Utils/utils";


export function loadCodeManagement(){

    const zeilen = ['Code', 'Codes'];
    $("#activation-codes").DataTable({
        language: getTableLang({}, zeilen),
        columnDefs: [
            {"orderable": false, "targets": [0,6]}
        ]
    });

    const list = new chooseListWithButtons("#add-courses-to-activation-code-wrapper", ".m-f-t-item", ".add-course-to-be-activated");
    const list2 = new chooseListWithButtons("#edit-courses-to-activation-code-wrapper", ".m-f-t-item", ".add-course-to-be-activated");

    $("input[name='count-activations']").TouchSpin({
        min: 1,
        buttondown_class: "btn btn-light-danger text-danger font-medium",
        buttonup_class: "btn btn-light-success text-success font-medium",
    });

    const openEditActivationCodeModal = function(code:string, btn:JQuery){

        const url = '/code/' + code;

        const success = function(data){
            data.activationsData = []; // TODO
            initEditActivationCodeModal(data.max_activations, data.courses, data.activationsData, data.name);
            $("#edit-activation-code-modal").attr('data-code', code);
            showModal("edit-activation-code-modal");
        }

        ajaxRequest(url, success, {}, btn);

    }

    var initEditActivationCodeModal = function(amount, activatedCourses, activatedStudents, codeName){
        const modal = $("#edit-activation-code-modal");
        modal.find(".count-activations").val(amount);
        modal.find(".code-name").val(codeName);
        const courses = modal.find(".m-f-t-item");
        courses.each((ind, obj) => {
            const courseId = $(obj).find(".add-course-to-be-activated").attr('data-fach');
            if (activatedCourses.includes(Number(courseId))){
                list2.turnItemPositive($(obj));
            }
        })

        let html = '<div class="h6 text-muted">Übersicht über Aktivierungen</div>';
        html += '<div class="w-100">';
        if (activatedStudents.length > 0) {
            activatedStudents.forEach((student) => {
                html += '<div class="d-flex">' + student.name + '<div class="ms-auto">' + student.date + '</div></div>'
            });
        } else {
            html += '<div class="text-center mt-3">Noch niemand hat sich mit diesem Code aktiviert</div>';
        }
        html += '';
        $("#activated-students-wrapper").html(html);

    }

    const createNewActivationCode = function(courses, amount, name, instanceId, btn=false){

        const url = '/code/create/' + instanceId.toString();

        const data = {
            amount: amount,
            courses: courses,
            name: name,
        }

        const success = function(data){
            successToast("Code Erstellt");
            location.reload();
        }

        ajaxRequest(url, success, data, btn);

    }

    const editActivationCode = function(code, courses, amount, name, btn=false){

        const url = '/code/update/' + code;

        const data = {
            amount: amount,
            courses: courses,
            name: name,
            code: code,
        }

        const success = function(data){
            successToast("Code Überarbeitet");
            location.reload();
        }

        ajaxRequest(url, success, data, btn);
    }

    const deleteActivationCode = function(code:string, btn:boolean|JQuery=false){

        const url = '/code/delete/' + code

        const success = function(data){
            successToast("Code wurde gelöscht", "Erfolg", 4000);
            if (btn){
                btn.parents("tr").remove();
            }
        }

        ajaxRequest(url, success, {}, btn);

    }

    $(document).on("click", ".display-qr-code", function(){
        const code = $(this).parent().parent().find(".activation-code").html() + '/use';
        const instanceId = $("#instance-id").val().toString()
        const path = 'https://pexam.de/code/' + instanceId + '/';
        displayQrCode(code, path)
    })

    $(document).on("click", ".edit-activation-code", function(){
        const code = $(this).parent().parent().find(".activation-code").html();
        openEditActivationCodeModal(code, $(this));
    })


    const getCodeSelectedInfo = function(modal){
        const amount = modal.find(".count-activations").val();
        const name = modal.find(".code-name").val();
        const ccs = modal.find(".m-f-t-item.chosen");
        const courses = [];
        ccs.each((ind, obj) => {
            const courseId = $(obj).find(".add-course-to-be-activated").attr('data-fach');
            courses.push(courseId)
        })
        return [amount, courses, name]
    }

    $(".create-new-activation-code").on("click", function(){
        const modal = $("#create-activation-code-modal")

        const instanceId = $("#instance-id").val();

        const [amount, courses, name] = getCodeSelectedInfo(modal);
        if (courses.length > 0) {
            createNewActivationCode(courses, amount, name, instanceId, $(this))
        } else {
            errorToast("Es muss mindestens ein Kurs ausgewählt werden", "Fehler");
        }
    });

    $(".update-activation-code").on("click", function(){
        const modal = $("#edit-activation-code-modal");
        const [amount, courses, name] = getCodeSelectedInfo(modal);
        const code = modal.attr('data-code');
        if (courses.length > 0) {
            editActivationCode(code, courses, amount, name, $(this))
        } else {
            errorToast("Es muss mindestens ein Kurs ausgewählt werden", "Fehler");
        }
    })

    $(".delete-activation-code").on("click", function(){
        const code = $(this).parent().parent().find(".activation-code").html();
        const confirmed = confirm("Sicher, dass du diesen Code löschen möchtest?");
        if (confirmed) {
            deleteActivationCode(code, $(this));
        }
    })

}